import { api } from 'src/plugins/axios'
import { createQueryString, serializeObject } from 'src/utils'

export default {
  fetchClassApprovals,
  fetchInstructors,
  resetState,
  instructorAutocomplete,
  affiliateAutocomplete,
  classAddressCheck
}

/**
 * How the student addresses in a class stand with Google, for the warning an
 * admin sees before approving. Null when the check could not be made.
 */
async function classAddressCheck ({ commit }, classId) {
  try {
    const { data } = await api.post('/approvals/classAddressCheck', { classId })
    return data && data.success ? data.payload : null
  } catch (err) {
    console.log('class address check failed', err)
    return null
  }
}

async function fetchClassApprovals ({ commit, state }, { pagination, filter, columns, customFilter, exportOptions }) {
  commit('isLoading')
  try {
    let query = createQueryString({ pagination, filter, columns, customFilter, exportOptions })

    let fieldQuery
    
    let finalSearchFields = _.pickBy(state.classSearchFields, v => {
        return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
    })
    if(finalSearchFields['DATE_CREATED']){
      finalSearchFields['DATE_CREATED'] = finalSearchFields['DATE_CREATED'].slice(0,10)
    }
    if (!_.isEmpty(finalSearchFields)) {
        fieldQuery = serializeObject({ searchFields: { ...finalSearchFields } })
    }
    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')

    const { data: response } = await api.get('/approvals/fetchClasses/' + finalQuery)
    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response
    if (!exportOptions) commit('setList', { approvals: payload.approvals })
    return response
  } catch (response) {
    console.log(response)
    commit('doneLoading')
    return response
  }
}

async function instructorAutocomplete({commit, state}, search){
  try{
      let { data } = await api.post('/classes/getInstructors', {s: search})
      let { success, payload } = data
      return payload
  }
  catch(err){
      return []
  }
}

async function affiliateAutocomplete({commit, state}, search){
  try{
      let { data } = await api.post('/affiliate/classAffiliateDropdown', {s: search})
      let { success, payload } = data
      return payload
  }
  catch(err){
      return []
  }
}

async function fetchInstructors ({ commit }, { pagination, filter, columns, customFilter, exportOptions }) {
  commit('isLoading')
  try {
    const query = createQueryString({ pagination, filter, columns, customFilter, exportOptions })
    const { data: response } = await api.get('/approvals/fetchInstructors/' + query)
    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response
    if (!exportOptions) commit('setList', { approvals: payload.approvals })
    // notify.respond(response)
    return response
  } catch (response) {
    commit('doneLoading')
    // notify.respond(response)
    return response
  }
}

function resetState (state) {
  _.each(state, (value, key) => {
      state[key] = initialState[key]
  })
}